import { CommonModule } from '@angular/common';
import { Component, computed, effect, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { getFromStorage, saveToStorage } from '../../../../helpers/storageUtils';
import { LeadResponse } from '../../../../Models/leadResponse';
import { UpdateLead } from '../../../../Models/updateLead';
import { LOADER_MOTO, ONEROSO } from '../../../../routes.constans';
import { LeadsService } from '../../../../services/Leads/leads.service';
import { ButtonComponent } from '../../../components/button/button.component';
import { DetailsVehicleBannerComponent } from '../../../components/details-vehicle-banner/details-vehicle-banner.component';

import { catchError, of } from 'rxjs';
import { BannerAppComponent } from '../../../../components/banner-app/banner-app.component';
import { FooterAppComponent } from '../../../../components/footer-app/footer-app.component';
import { DataLayerService } from '../../../../services/DataLayer/data-layer.service';
import { InactivityService } from '../../../../services/inactivity/inactivity.service';
import { OnerousStateService } from '../../../services/onerous/onerous-state.service';
import { UtmHandlerService } from '../../../services/utm-handler.service';
import { ACCESORIES, CEROKM, FINANCIED } from '../../onerous-pages.constants';

@Component({
  selector: 'app-onerous-initial-page',
  templateUrl: './onerous-initial-page.component.html',
  imports: [
    CommonModule,
    FormsModule,

    BannerAppComponent,
    ButtonComponent,
    DetailsVehicleBannerComponent,
    FooterAppComponent,
  ],
  standalone: true,
  styleUrl: './onerous-initial-page.component.scss',
})
export class OnerousInitialPageComponent implements OnInit, OnDestroy {
  utmHandlerService = inject(UtmHandlerService);
  private dataLayerService = inject(DataLayerService);
  private onerousStateService = inject(OnerousStateService);
  checkFinanced = signal<boolean>(false);
  checkCeroKM = signal<boolean>(false);
  checkAccessories = signal<boolean>(false);
  router = inject(Router);
  inactivityService = inject(InactivityService);

  buttonTitle = signal<string>('Ninguno, continuar');
  updatedLeadData: UpdateLead = {} as UpdateLead;
  leadService = inject(LeadsService);

  ngOnInit(): void {
    //const isFinanced = this.storageService.getItem('Prenda');
    this.inactivityService.stopTimer();
    this.inactivityService.startDefaultTimerForScreen(
      'Caracteristicas-vehiculo',
      'Abandono Características vehículo',
      '40',
    );

    const isFinanced = getFromStorage<boolean>('Prenda', 'session');

    if (isFinanced) {
      this.checkFinanced.set(true);
    }

    this.dataLayerService.pushDataLayerOnerous(
      'Pageview',
      'moto_ecommerce_step_2.1_pregunta_condicional',
      'Pregunta condicional',
    );
  }

  private routeMap: Record<string, { route: string; sessionKey: string }> = {
    '010': { route: `/${ONEROSO}/${ACCESORIES}`, sessionKey: 'Accesorios' },
    '001': { route: `/${ONEROSO}/${CEROKM}`, sessionKey: '0KM' },
    '100': { route: `/${ONEROSO}/${FINANCIED}`, sessionKey: 'Prenda' },
    '011': { route: `/${ONEROSO}/${ACCESORIES}`, sessionKey: '0KMAccesorios' },
    '110': { route: `/${ONEROSO}/${FINANCIED}`, sessionKey: 'PrendaAccesorios' },
    '101': { route: `/${ONEROSO}/${FINANCIED}`, sessionKey: '0KMPrenda' },
    '111': { route: `/${ONEROSO}/${FINANCIED}`, sessionKey: 'full' },
  };

  anyChecked = computed(() => {
    return this.checkFinanced() || this.checkCeroKM() || this.checkAccessories();
  });

  private _checkEffect = effect(
    () => {
      const val = this.checkAccessories() || this.checkCeroKM() || this.checkFinanced();

      //VALIDAR PORQUÉ NO SE PUEDE USAR TERNARIOS.
      if (val) {
        this.buttonTitle.set('Continuar');
      } else {
        this.buttonTitle.set('Ninguno, continuar');
      }
    },
    { allowSignalWrites: true },
  );

  handleClick(): void {

    const data = getFromStorage<LeadResponse>('LeadResponse', 'session');
    const financed = this.checkFinanced();
    const accessories = this.checkAccessories();
    const ceroKm = this.checkCeroKM();
    const key = `${+financed}${+accessories}${+ceroKm}`;
    const isAnnualPlan = ['110', '100', '111'].includes(key);
    const config = this.routeMap[key];
    const targetRoute = this.anyChecked() && config ? config.route : LOADER_MOTO;
    const leadData: any = data;
    const leadId = leadData?.lead_id || '';

    this.onerousStateService.saveSelection(financed, accessories, ceroKm);
    saveToStorage('Onlyannualplan', isAnnualPlan, 'session');
    this.leadService
      .UpdateInfoLead(this.buildOnerousReqquest(), leadId)
      .pipe(
        catchError((error) => {
          console.error('Error no bloqueante al actualizar lead:', error);
          return of({ success: false, data: null });
        })
      )
      .subscribe((response) => {
        if (this.anyChecked() && config) {
          saveToStorage('OnerousSelection', config.sessionKey, 'session');
        }
        else {
          saveToStorage('OnerousSelection', 'none', 'session');
        }
        if (response?.data) {
          saveToStorage('UpdatedLeadData', response.data, 'session');
        }
        this.router.navigate([targetRoute]);
      });
  }

  private buildOnerousReqquest() {
    const data = getFromStorage<LeadResponse>('LeadResponse', 'session');
    //const data = this.storageService.getLeadData();
    const isFinanced = this.checkFinanced();
    const hasAccessories = this.checkAccessories();
    const isCeroKM = this.checkCeroKM();
    const leadData: any = data;
    const leadId = leadData?.data ? leadData.data.Id : leadData?.lead_id || '';
    const acceptTos = leadData?.accept_tos ?? true;
    console.log('Lead ID:', data);
    const updateOnerousData = {
      lead_id: leadId,
      accept_tos: acceptTos,
      ...(isFinanced && { prenda: isFinanced }),
      ...(hasAccessories && { TieneAccesoriosAdicionales: hasAccessories }),
      ...(isCeroKM && { '0KM': isCeroKM }),
      set_utm_campaign: this.utmHandlerService.getUtmParams()['utm_campaign'] || '',
      set_utm_content: this.utmHandlerService.getUtmParams()['utm_content'] || '',
      set_utm_medium: this.utmHandlerService.getUtmParams()['utm_medium'] || '',
      set_utm_source: this.utmHandlerService.getUtmParams()['utm_source'] || '',
    };

    return updateOnerousData;
  }

  ngOnDestroy() {
    this.inactivityService.stopTimer();
  }
}
